import { DashboardNotification } from '@sp-types/notificationType';
import { adminGetItems, getItems, saveItemGenerateId, updateItem } from './genericFB';

const collection = 'Notifications';

export async function addNotification(notification: DashboardNotification): Promise<DashboardNotification | null> {
  return saveItemGenerateId<DashboardNotification>(notification, collection);
}

export async function getNotifications(accountId: string): Promise<DashboardNotification[] | undefined> {
  return getItems<DashboardNotification>(accountId, collection, undefined, true);
}

export async function getAdminAllNotifications(): Promise<DashboardNotification[] | undefined> {
  return adminGetItems<DashboardNotification>(collection);
}

export async function updateNotification(
  noteId: string,
  partial: Partial<DashboardNotification>,
): Promise<DashboardNotification | null> {
  return updateItem<DashboardNotification>(noteId, partial, collection);
}
